import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useApi } from './useApi';

const HEARTBEAT_MS = 60_000;

/**
 * Meldet tatsächliche Aktivität an die API: bei jedem Seitenwechsel sowie als
 * Heartbeat (solange der Tab sichtbar ist). So zählt auch reines Ansehen einer
 * Seite ohne Änderung. Fehler werden bewusst ignoriert (Präsenz ist best-effort).
 */
export function usePresencePing() {
  const api = useApi();
  const { pathname } = useLocation();
  const pathRef = useRef(pathname);
  pathRef.current = pathname;

  // Ping bei jedem Seitenwechsel
  useEffect(() => {
    api.pingActivity(pathname).catch(() => {});
  }, [api, pathname]);

  // Heartbeat, solange der Tab sichtbar ist
  useEffect(() => {
    const tick = () => {
      if (document.visibilityState === 'visible') {
        api.pingActivity(pathRef.current).catch(() => {});
      }
    };
    const id = window.setInterval(tick, HEARTBEAT_MS);
    document.addEventListener('visibilitychange', tick);
    return () => {
      window.clearInterval(id);
      document.removeEventListener('visibilitychange', tick);
    };
  }, [api]);
}
